import FixedMatrixHeader from './fixed-matrix-header-component';

const MODULE_NAME = 'app.common.fixed-matrix-header';
const module = angular.module(MODULE_NAME, [])
    .directive(FixedMatrixHeader.DIRECTIVE_NAME, FixedMatrixHeader);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/cars/directives/fixed-matrix-header/fixed-matrix-header-module.js